import img1 from "../../assets/images/authImages/authBg.png";
import img2 from "../../assets/images/authImages/authBg-2.jpg";
import img3 from "../../assets/images/authImages/authBg-3.jpg";
import img4 from "../../assets/images/authImages/authBg-4.jpg";
import img5 from "../../assets/images/authImages/authBg-5.jpg";

export const welcomeSlides = [
  {
    header: "Welcome to Sports In!",
    description: "Unlock your potential. Start your sports journey today!",
    image: img1,
  },
  {
    header: "Join the Community!",
    description: "Connect with fellow sports enthusiasts and stay motivated.",
    image: img2,
  },
  {
    header: "Track Your Progress!",
    description: "Monitor your performance and achieve your fitness goals.",
    image: img3,
  },
  {
    header: "Get Expert Advice!",
    description: "Learn from the best with our curated sports articles.",
    image: img4,
  },
  {
    header: "Get Expert Advice!",
    description: "Learn from the best with our curated sports articles.",
    image: img5,
  },
];
